module.exports = __webpack_public_path__ + "assets/img/2018_2.9151b58c.png";